const getProjectMemberPackage = (context, projectId) => {
  return context.ProjectMembershipPackages
    .find(p => p.Project.ID === projectId);
}

export const IsUserProjectMember = (context, projectId) => {
  return Boolean(getProjectMemberPackage(context, projectId));
}

export const IsUserProjectAdmin = (context, projectId) => {
  const projectMemberPackage = getProjectMemberPackage(context, projectId);
 return projectMemberPackage && projectMemberPackage.ProjectMember.IsAdmin;
}

export const IsContentRemovalDisallowedForMember = (context, projectId) => {
  const projectMemberPackage = getProjectMemberPackage(context, projectId);
  if (!projectMemberPackage || projectMemberPackage.ProjectMember.IsAdmin) {
    return false;
  }
  return Boolean(projectMemberPackage.Project.Access
    && projectMemberPackage.Project.Access.MemberAccess
    && projectMemberPackage.Project.Access.MemberAccess.DisallowContentRemovalByMembers);
}